import { DataPoint } from '@src/types/DataPoint';
import ProgressBar from './ProgressBar/ProgressBar';
import useSubscription from '@src/hooks/useSubscription';
import { Actions } from '@src/types/Actions';
import useGetInternalWidgetConfig from '@src/hooks/api/queries/useGetInternalWidgetConfig';
import { WidgetTypePointList } from '@src/types/Widget';
import { SiteMeta } from '@src/types/SiteMeta';
import { Box } from '@mui/material';
import storeConnector from '@src/store/storeConnector';
import { useSOCConfig } from '@src/hooks/useSOCConfig';
import useAlias from '@src/hooks/useAlias';

interface SiteSOCProps {
  siteMeta: SiteMeta;
  actions: Actions;
}

interface SOCProgressBarProps {
  datapoint: DataPoint[];
  max: number;
  min: number;
  isLoading?: boolean;
}

function SOCProgressBar({
  datapoint,
  max,
  min,
  isLoading,
}: SOCProgressBarProps) {
  const dpWVal = useSubscription(datapoint);
  const value = dpWVal[0]?.value ?? (0 as number);
  const alias = useAlias();

  return (
    <ProgressBar
      title={alias('SOC')}
      value={value}
      loading={isLoading}
      styleClass={min > +value || +value > max ? 'red' : ''}
    />
  );
}

function SiteSOC({ siteMeta, actions }: SiteSOCProps) {
  const { data: widgetConfig, isLoading } =
    useGetInternalWidgetConfig<WidgetTypePointList>(
      'site_SOC',
      {},
      {
        queryKeys: ['site_soc'],
      },
    );

  const socRange = useSOCConfig(actions, siteMeta.siteId);

  return (
    <Box>
      {widgetConfig?.dataPoints && widgetConfig.dataPoints.length > 0 && (
        <SOCProgressBar
          datapoint={widgetConfig.dataPoints[0]}
          max={socRange.max}
          min={socRange.min}
          isLoading={isLoading}
        />
      )}
    </Box>
  );
}

export default storeConnector(SiteSOC, {
  user: ['role'],
  config: ['siteMeta'],
});
